import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {LoginModalContext} from '@adv-mt/mt-context-login-modal'
import FormSellVehicle from '@adv-mt/mt-form-sell-vehicle'

import {useVehicleAppraiserAnalyticsTrack} from '../../hooks/useVehicleAppraiserAnalyticsTrack.js'

const BASE_CLASS_NAME = 'mt-VehicleAppraiserPage'

const AppraiserForm = ({isLogged, onAppraise, sellVehicleConfigForm, handleErrorFetchingRecommendedPrice}) => {
  const {domain, i18n} = useContext(Context)
  const {triggerLoginModal} = useContext(LoginModalContext)

  const [isButtonLoader, setIsButtonLoader] = useState(true)

  const config = domain.get('config')
  const {LOGIN_SOURCE_ID_APPRAISER} = config.get('login')
  const {formErrorTypes, formFieldIds} = config.get('form')
  const {HIT_ORIGINS} = config.get('tracking')

  const {trackAppraisalError, trackFormFieldValueAutocompleted, trackFormFieldValueChange} =
    useVehicleAppraiserAnalyticsTrack()

  const handleOnSubmitFormVehicle = ({fields}) => {
    domain
      .get('get_recommended_price_seller_use_case')
      .execute({...fields})
      .then(([error, response = {}]) => {
        if (error) {
          trackAppraisalError({
            errorType: formErrorTypes.serverError
          })
          return handleErrorFetchingRecommendedPrice({...response, ...fields})
        }
        onAppraise({...response, ...fields})
      })
  }

  const onFormSubmit = ({fields}) => {
    setIsButtonLoader(true)
    isLogged
      ? handleOnSubmitFormVehicle({fields})
      : triggerLoginModal({
          modalProps: {
            source: LOGIN_SOURCE_ID_APPRAISER,
            trackingOrigin: HIT_ORIGINS.OTHERS,
            onLogin: () => handleOnSubmitFormVehicle({fields}),
            onClose: () => {
              setIsButtonLoader(false)
            }
          }
        })
  }

  return (
    <div className={`${BASE_CLASS_NAME}-formContainer`}>
      <FormSellVehicle
        buttonText={i18n.t('LANDING_VEHICLE_APPRAISER.GET_APPRAISAL')}
        customFields={{
          [formFieldIds.postalCode]: {
            help: i18n.t('LANDING_VEHICLE_APPRAISER.FORM.LOCATION.HELP')
          }
        }}
        isButtonLoader={isButtonLoader}
        onFormFieldsError={trackAppraisalError}
        onFormFieldValueAutocompleted={trackFormFieldValueAutocompleted}
        onFormFieldValueChange={trackFormFieldValueChange}
        onSubmit={onFormSubmit}
        sellVehicleConfigForm={sellVehicleConfigForm}
        isEnabledNewLandingAppraisalDesign
      />
    </div>
  )
}

AppraiserForm.displayName = 'AppraiserForm'
AppraiserForm.propTypes = {
  isLogged: PropTypes.bool,
  onAppraise: PropTypes.func.isRequired,
  sellVehicleConfigForm: PropTypes.object,
  handleErrorFetchingRecommendedPrice: PropTypes.func
}

export default AppraiserForm
